import { z } from "zod/v4";
import { getDeposito } from "../../depositos/api/get-deposito";
import { getAllDepositos } from "../../depositos/api/get-all-depositos";
import { Form, FormProps } from "@/components/form";
import { Stack } from "@mui/material";

export const depositoAssignFormSchema = z.object({
    depositoId: z.string()
})

export default function DepositoAssignForm({
    form,
    ...props
}: FormProps<z.input<typeof depositoAssignFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Stack maxWidth={"350px"}>
            <Form.ModelComboBox name="depositoId" label="Depósito" get={getDeposito} getAll={getAllDepositos} size="small" />
        </Stack>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"end"}>
            <Form.SubmitButton>Guardar</Form.SubmitButton>
        </Stack>
    </Form>
}
